import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Record_search extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_record_search">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Record.search</h2>
              <p>
                NL.Record.search allows you to search custom and system records
                from the Application and Workflow events.
              </p>
              <p>
                For more informaiton on query, sort, scrolling etc refer to the
                API search record article.
              </p>
              <WorkflowCompatibility front={true} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>

                  <tr>
                    <td className="b">from</td>
                    <td>
                      Ignore the first X number of results.
                      <br />
                      <i>integer default is 0</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">output</td>
                    <td>
                      Select specific fields you wish to output
                      <br />
                      <i>string array default is undefined</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">query</td>
                    <td>
                      Allows you to pass search filter criteria
                      <br />
                      <i>object default is undefined</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">scroll</td>
                    <td>
                      Allows you to scroll through many results via multiple
                      requests.
                      <br />
                      <i>true, false default is undefined</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">scroll_id</td>
                    <td>
                      Allows you to contiune scrolling through scrolled results
                      <br />
                      <i>string default is undefined</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">size</td>
                    <td>
                      The max number of results retrieved per request
                      <br />
                      <i>integer default is 100 maximum is 10000</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">sort</td>
                    <td>
                      Sort the results
                      <br />
                      <i>
                        mixed string and objet array default sorts by score then
                        last updated
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">system_record</td>
                    <td>
                      System object like user, group, workflow etc.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Record.search Example</h2>
              <p>This example searches incident records.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">type</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonA">"</span>
                  <span className="jsonG">incident</span>
                  <span className="jsonA">";</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">system_record</span>
                  <span className="jsonA">: </span>
                  <span className="jsonO">false</span>
                  <span className="jsonA">,</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">query</span>
                  <span className="jsonA">: </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="nodeCode">term</span>
                  <span className="jsonA">: </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i3">
                  <span className="nodeCode">text_status</span>
                  <span className="jsonA">: </span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">open</span>
                  <span className="jsonA">"</span>
                </div>
                <div className="i2">
                  <span className="jsonY">&#125;</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Record</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">search</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">type</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>

                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>

                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Record_search;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Record_search.js